module.exports = __webpack_public_path__ + "static/media/top.36cfbbc5.jpg";